// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"0bfee779","151":"c481ee09","278":"e7ab7028","359":"1dff07dc","680":"dcd5200e","896":"90a7aa90"}[chunkId] + ".chunk.js";
};